export default __webpack_public_path__ + "static/media/prana04.294ad036.JPG";